"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/components/form-parts/events");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const voices_helper_1 = require("@front/helpers/voices.helper");
const component_3 = require("@front/layouts/default-layout/component");
const translations_1 = require("@front/application/globals/translations");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const uuid_1 = require("uuid");
require("@front/components/rag-settings/component");
require("@front/components/form-parts/switch/component");
require("@front/components/api-tool-setup/component");
const AVAILABLE_TOOLS = backendImport_1.frontAppTools;
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="avatar-form-page">
    <div class="row">
      <div class="col-lg-12 col-12 pb-lg-5">
        <div class="mb-2">
          <h1>${x => x.avatarId ? ('avatar.form.title.edit'.t() + `: ${x.form.name}`) : 'avatar.form.title.add'.t()}</h1>
          <div class="text-zero top-right-button-container">
            <button @click="${(x, c) => x.back()}" type="button"
              class="top-right-button mr-1 btn btn-primary btn-lg">${'avatar.form.back'.t()}</button>
          </div>
        </div>
        <div class="card card-body mb-5">
          <the-form :onSubmit="${x => x.handleSubmit.bind(x)}">
            
            <ul class="nav nav-tabs nav-fill mb-4" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link ${x => x.activeTab === 'configuration' ? 'active' : ''}" type="button"
                  role="tab" @click="${x => x.switchTab('configuration')}">
                  ${'avatar.form.tab.configuration'.t()}
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link ${x => x.activeTab === 'knowledge' ? 'active' : ''}" type="button" role="tab"
                  @click="${x => x.switchTab('knowledge')}">
                  ${'avatar.form.tab.knowledge'.t()}
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link ${x => x.activeTab === 'instructions' ? 'active' : ''}" type="button" role="tab"
                  @click="${x => x.switchTab('instructions')}">
                  ${'avatar.form.tab.instructions'.t()}
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link ${x => x.activeTab === 'tools' ? 'active' : ''}" type="button" role="tab"
                  @click="${x => x.switchTab('tools')}">
                  ${'avatar.form.tab.tools'.t()}
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link ${x => x.activeTab === 'webhooks' ? 'active' : ''}" type="button" role="tab"
                  @click="${x => x.switchTab('webhooks')}">
                  ${'avatar.form.tab.webhooks'.t()}
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link ${x => x.activeTab === 'apiTools' ? 'active' : ''}" type="button" role="tab"
                  @click="${x => x.switchTab('apiTools')}">
                  ${'avatar.form.tab.apiTools'.t()}
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link ${x => x.activeTab === 'lexicon' ? 'active' : ''}" type="button" role="tab"
                  @click="${x => x.switchTab('lexicon')}">
                  ${'avatar.form.tab.lexicon'.t()}
                </button>
              </li>
              ${(0, fast_element_1.when)(x => x.isUserSuperAdmin, (0, fast_element_1.html) `
              <li class="nav-item" role="presentation">
                <button class="nav-link ${x => x.activeTab === 'rag' ? 'active' : ''}" type="button" role="tab"
                  @click="${x => x.switchTab('rag')}">
                  ${'avatar.form.tab.rag'.t()}
                </button>
              </li>
              `)}
            </ul>

            
            <div class="tab-content">
              
              ${(0, fast_element_1.when)(x => x.activeTab === 'configuration', (0, fast_element_1.html) `
              <div class="tab-pane active" role="tabpanel">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <part-input required="true" class="form-part" label="${'avatar.form.name.label'.t()}"
                      :value="${x => x.form.name}" name="name" placeholder="${'avatar.form.name.placeholder'.t()}"
                      required="true"></part-input>
                  </div>
                  <div class="form-group col-md-6">
                    <part-select class="form-part" label="${'avatar.form.gender.label'.t()}"
                      :value="${x => x.form.gender}" name="gender" placeholder="${'avatar.form.gender.placeholder'.t()}"
                      :options="${x => [
    { label: 'avatar.form.gender.none'.t(), value: null },
    { label: 'avatar.form.gender.male'.t(), value: 'male' },
    { label: 'avatar.form.gender.female'.t(), value: 'female' }
]}"></part-select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <part-input class="form-part" label="${'avatar.form.age.label'.t()}" :value="${x => x.form.age}"
                      name="age" type="number" placeholder="${'avatar.form.age.placeholder'.t()}"></part-input>
                  </div>
                  <div class="form-group col-md-6">
                    <part-select class="form-part" label="${'avatar.form.voice.label'.t()}"
                      :value="${x => x.form.voice || ''}" name="voice"
                      placeholder="${'avatar.form.voice.placeholder'.t()}"
                      :options="${x => x.currentVoiceOptions}"></part-select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>${'avatar.form.logo.label'.t()}</label>
                    <part-file-upload class="form-part" :value="${x => x.form.logo}" name="logo" accept="image/*"
                      placeholder="${'avatar.form.logo.label'.t()}"
                      :onSelectFile="${x => x.onLogoUpload.bind(x)}"></part-file-upload>
                  </div>
                  <div class="col-md-6">
                    ${(0, fast_element_1.when)(x => x.form.logo, (0, fast_element_1.html) `
                    <div class="avatar-logo-preview mt-3 mb-3">
                      <img src="${x => !x.avatarId ? `data:${x.form.logo.mimeType};base64,${x.form.logo.path}` : `/uploads/${x.form.logo.filename}`}" alt="Avatar Logo" class="img-fluid rounded" />
                    </div>
                    `)}
                  </div>
                </div>
                <div class="form-group">
                  <part-textarea resize="h" required="true" class="form-part"
                    label="${'avatar.form.description.label'.t()}" :value="${x => x.form.description}"
                    name="description" type="textarea"
                    placeholder="${'avatar.form.description.placeholder'.t()}"></part-textarea>
                </div>
                <div class="form-row mt-4">
                  <div class="col-3">
                    <p><strong>${'avatar.form.model.label'.t()}</strong></p>
                    <simple-model-select noAvatar="true" inForm="true" value="${x => { var _a; return (_a = x.form.model) === null || _a === void 0 ? void 0 : _a.model.value; }}"
                      placeholder="${'avatar.form.model.placeholder'.t()}" :onChange="${x => x.onSelect.bind(x)}">
                    </simple-model-select>
                  </div>
                </div>
                ${(0, fast_element_1.when)(x => { var _a; return (_a = x.form.model) === null || _a === void 0 ? void 0 : _a.canTalk; }, (0, fast_element_1.html) `
                <div class="form-group mt-4">
                  <part-checkbox class="form-part" label="${'avatar.voiceAgent'.t()}"
                    :value="${x => x.form.isVoiceAgent}" name="isVoiceAgent">
                  </part-checkbox>
                </div>
                `)}
                ${(0, fast_element_1.when)(x => x.isUserSuperAdmin, (0, fast_element_1.html) `
                <div class="form-group mt-4">
                  <part-checkbox class="form-part" label="${'avatar.common'.t()}" :value="${x => x.form.common}"
                    name="common">
                  </part-checkbox>
                  <small class="form-text text-muted">${'avatar.common.help'.t()}</small>
                </div>
                `)}
                <div class="form-group">
                  <part-switch class="form-part" label="${'avatar.active'.t()}" :value="${x => x.form.active}"
                    name="active">
                  </part-switch>
                </div>
              </div>
              `)}

              
              ${(0, fast_element_1.when)(x => x.activeTab === 'knowledge', (0, fast_element_1.html) `
              <div class="tab-pane active" role="tabpanel">
                <div class="form-group mt-4">
                  <knowledge-picker forcedShow="true" selectedIds="${x => x.form.knowledgeIds.join(',')}"
                    fullKnowledgeIds="${x => x.form.fullKnowledgeIds.join(',')}"
                    initial-show="${x => x.form.knowledgeIds.length > 0}" label="${' avatar.form.knowledge.label'.t()}"
                    placeholder="${'avatar.form.knowledge.placeholder'.t()}"
                    @selectionChanged="${(x, c) => x.onKnowledgeSelectionChanged(c.event)}"></knowledge-picker>
                </div>
              </div>
              `)}

              
              ${(0, fast_element_1.when)(x => x.activeTab === 'instructions', (0, fast_element_1.html) `
              <div class="tab-pane active instructions" role="tabpanel">
                <div class="form-group mt-4">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5>${'avatar.form.instructions.title'.t()}</h5>
                    <button type="button" class="btn btn-primary btn-sm" @click="${x => x.addInstructionEntry()}">
                      <i class="simple-icon-plus mr-1"></i>${'avatar.form.instructions.add'.t()}
                    </button>
                  </div>
                  <p class="text-muted mb-4">${'avatar.form.instructions.description'.t()}</p>

                  ${(0, fast_element_1.when)(x => !x.form.avatarInstructions || x.form.avatarInstructions.length === 0, (0, fast_element_1.html) `
                  <div class="alert alert-info">
                    <i class="simple-icon-info mr-2"></i>${'avatar.form.instructions.empty'.t()}
                  </div>
                  `)}

                  ${(0, fast_element_1.repeat)(x => x.form.avatarInstructions || [], (0, fast_element_1.html) `
                  <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center row">
                      <div class="title-wrapper">
                        <div class="col-3 pt-2">
                          <part-input class="form-part" hybridLabelMode="true"
                            :badgeColor="${entry => entry.color}"
                            label="${'avatar.form.instructions.layer.label'.t()}" :value="${entry => entry.layer}"
                            name="instructionLayer_${entry => entry.id}"
                            placeholder="${'avatar.form.instructions.layer.placeholder'.t()}"></part-input>
                        </div>
                        ${(0, fast_element_1.when)((x, c) => c.parent.showColor, (0, fast_element_1.html) `<div class="col-2 pt-2">
                          <part-input class="form-part " type="color" :value="${entry => entry.color}"
                            name="instructionColor_${entry => entry.id}"
                            placeholder="${'avatar.form.instructions.color.placeholder'.t()}"></part-input>
                        </div>`)}
                      </div>
                      <div>
                        <button type="button" class="btn btn-danger btn-sm"
                          @click="${(entry, c) => c.parent.removeInstructionEntry(entry)}">
                          <i class="simple-icon-trash"></i>
                        </button>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <part-textarea class="form-part" label="${'avatar.form.instructions.prompt.label'.t()}"
                            :value="${entry => entry.instructionPrompt}" name="instructionPrompt_${entry => entry.id}"
                            placeholder="${'avatar.form.instructions.prompt.placeholder'.t()}"></part-textarea>

                        </div>
                        <div class="form-group col-md-6">
                          <part-textarea class="form-part" label="${'avatar.form.instructions.notes.label'.t()}"
                            :value="${entry => entry.notes}" name="instructionNotes_${entry => entry.id}"
                            placeholder="${'avatar.form.instructions.notes.placeholder'.t()}"></part-textarea>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-12">
                          <label>${'avatar.form.instructions.file.label'.t()} <span class="text-danger">*</span></label>
                          <part-file-upload class="form-part" :value="${entry => entry.file}"
                            name="instructionFile_${entry => entry.id}" accept=".txt,.md,.doc,.docx,.pdf"
                            required="true" placeholder="${'avatar.form.instructions.file.placeholder'.t()}"
                            :onSelectFile="${(entry, c) => (event) => c.parent.onInstructionFileUpload(entry.id, event)}"></part-file-upload>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="form-group col-12">
                          <part-checkbox class="form-part"
                            label="${'avatar.form.instructions.isPublic.label'.t()}"
                            name="instructionPublic_${entry => entry.id}"
                            :value="${entry => entry.isPublic}"></part-checkbox>
                        </div>
                      </div>

                      
                      ${(0, fast_element_1.when)(entry => !String(entry.id).startsWith('new_'), (0, fast_element_1.html) `
                      <div class="form-row mt-2">
                        <div class="form-group col-12">
                          <button type="button" class="btn btn-outline-secondary btn-sm"
                            @click="${(entry, c) => c.parent.toggleVersionHistory(entry.id)}">
                            <i class="simple-icon-clock mr-1"></i>
                            ${(entry, c) => c.parent.instructionVersionsOpen[entry.id]
    ? 'avatar.form.instructions.versions.hide'.t()
    : 'avatar.form.instructions.versions.show'.t()}
                          </button>

                          ${(0, fast_element_1.when)((entry, c) => c.parent.instructionVersionsLoading[entry.id], (0, fast_element_1.html) `
                          <app-loader block="true" width="15" height="15"></app-loader>
                          `)}

                          ${(0, fast_element_1.when)((entry, c) => c.parent.instructionVersionsOpen[entry.id] &&
    !c.parent.instructionVersionsLoading[entry.id], (0, fast_element_1.html) `
                          <div class="version-history-panel mt-2 border rounded p-3 pb-4">
                            <h6 class="mb-2 text-center">${'avatar.form.instructions.versions.title'.t()}</h6>

                            ${(0, fast_element_1.when)((entry, c) => !c.parent.instructionVersions[entry.id] ||
    c.parent.instructionVersions[entry.id].length === 0, (0, fast_element_1.html) `
                            <p class="text-muted small mb-0">${'avatar.form.instructions.versions.empty'.t()}</p>
                            `)}

                            ${(0, fast_element_1.repeat)((entry, c) => c.parent.instructionVersions[entry.id] || [], (0, fast_element_1.html) `
                            <div
                              class="version-entry d-flex justify-content-between align-items-center border-bottom py-2">
                              <div>
                                <span class="badge badge-secondary mr-2">v${version => version.versionNumber}</span>
                                <span class="small text-muted">${version => version.layer ||
    'avatar.form.instructions.untitled'.t()}</span>
                              </div>
                              <button type="button" class="btn btn-outline-primary btn-xs"
                                @click="${(version, c) => c.parentContext.parent.restoreInstructionVersion(c.parentContext.parent.form.avatarInstructions[c.parentContext.index].id, version)}">
                                ${'avatar.form.instructions.versions.restore'.t()}
                              </button>
                            </div>
                            `)}
                          </div>
                          `)}
                        </div>
                      </div>
                      `)}
                    </div>
                  </div>
                  `)}
                </div>
              </div>
              `)}

              
              ${(0, fast_element_1.when)(x => x.activeTab === 'tools', (0, fast_element_1.html) `
              <div class="tab-pane active" role="tabpanel">
                <div class="form-group mt-4">
                  <h5>${'avatar.form.tools.title'.t()}</h5>
                  <p class="text-muted mb-4">${'avatar.form.tools.description'.t()}</p>

                  <div class="row">
                    ${(0, fast_element_1.repeat)(x => x.availableTools, (0, fast_element_1.html) `
                    <div class="col-md-6 mb-3">
                      <div class="card h-100">
                        <div class="card-body">
                          <div class="d-flex align-items-start">
                            <part-checkbox name="enabledTool_${tool => tool.name}" class="form-part mr-3 mt-1"
                              :value="${tool => tool.enabled}"></part-checkbox>
                            <div class="flex-grow-1">
                              <h6 class="card-title mb-1">${tool => `tools.${tool.name}.name`.t()}</h6>
                              <p class="card-text text-muted small mb-0">${tool => `tools.${tool.name}.description`.t()}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    `)}
                  </div>
                </div>
              </div>
              `)}

              
              ${(0, fast_element_1.when)(x => x.activeTab === 'webhooks', (0, fast_element_1.html) `
              <div class="tab-pane active" role="tabpanel">
                
                <div class="form-group mt-4">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5>${'avatar.form.webhooks.definitions.title'.t()}</h5>
                    <button type="button" class="btn btn-primary btn-sm" @click="${x => x.addWebhookDefinition()}">
                      <i class="simple-icon-plus mr-1"></i>${'avatar.form.webhooks.definitions.add'.t()}
                    </button>
                  </div>

                  ${(0, fast_element_1.when)(x => !x.form.webhookDefinitions || x.form.webhookDefinitions.length === 0, (0, fast_element_1.html) `
                  <div class="alert alert-info">
                    <i class="simple-icon-info mr-2"></i>${'avatar.form.webhooks.definitions.empty'.t()}
                  </div>
                  `)}

                  ${(0, fast_element_1.repeat)(x => x.form.webhookDefinitions || [], (0, fast_element_1.html) `
                  <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">${definition => definition.name ||
    'avatar.form.webhooks.definitions.untitled'.t()}</h6>
                      <button type="button" class="btn btn-danger btn-sm mt-1"
                        @click="${(definition, c) => c.parent.removeWebhookDefinition(definition)}">
                        <i class="simple-icon-trash"></i>
                      </button>
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <part-input class="form-part" label="${'avatar.form.webhooks.definitions.name.label'.t()}"
                            :value="${definition => definition.name}" name="webhookName_${definition => definition.id}"
                            placeholder="${'avatar.form.webhooks.definitions.name.placeholder'.t()}"></part-input>
                        </div>
                        <div class="form-group col-md-6">
                          <part-input class="form-part" label="${'avatar.form.webhooks.definitions.address.label'.t()}"
                            :value="${definition => definition.address}"
                            name="webhookAddress_${definition => definition.id}"
                            placeholder="${'avatar.form.webhooks.definitions.address.placeholder'.t()}"></part-input>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <part-select class="form-part"
                            label="${'avatar.form.webhooks.definitions.eventType.label'.t()}"
                            :value="${definition => definition.eventType}"
                            name="webhookEventType_${definition => definition.id}"
                            :options="${(x, c) => c.parent.webhookEventTypeOptions}"></part-select>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <part-switch class="form-part"
                            label="${'avatar.form.webhooks.definitions.cronEnabled.label'.t()}"
                            :value="${definition => definition.cronEnabled}"
                            name="webhookCronEnabled_${definition => definition.id}"></part-switch>
                        </div>
                        <div class="form-group col-md-6">
                          <part-switch class="form-part" label="${'avatar.form.webhooks.definitions.active.label'.t()}"
                            :value="${definition => definition.active}"
                            name="webhookActive_${definition => definition.id}"></part-switch>
                        </div>
                      </div>

                      ${(0, fast_element_1.when)(definition => definition.cronEnabled, (0, fast_element_1.html) `
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <part-select class="form-part"
                            label="${'avatar.form.webhooks.definitions.cronInterval.label'.t()}"
                            :value="${definition => definition.cronInterval || '*/30 * * * *'}"
                            name="webhookCronInterval_${definition => definition.id}"
                            :options="${(x, c) => c.parent.cronIntervalOptions}"></part-select>
                          <small
                            class="form-text text-muted">${'avatar.form.webhooks.definitions.cronInterval.help'.t()}</small>
                        </div>
                      </div>
                      `)}

                      
                      <div class="form-row mt-3">
                        <div class="form-group col-12">
                          <part-switch class="form-part"
                            label="${'avatar.form.webhooks.definitions.authEnabled.label'.t()}"
                            :value="${definition => definition.authorizationEnabled}"
                            name="webhookAuthorizationEnabled_${definition => definition.id}"></part-switch>
                        </div>
                      </div>

                      ${(0, fast_element_1.when)(definition => definition.authorizationEnabled, (0, fast_element_1.html) `
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <part-input class="form-part"
                            label="${'avatar.form.webhooks.definitions.authHeader.label'.t()}"
                            :value="${definition => definition.authorizationHeader || ''}"
                            name="webhookAuthorizationHeader_${definition => definition.id}"
                            placeholder="${'avatar.form.webhooks.definitions.authHeader.placeholder'.t()}"></part-input>
                        </div>
                        <div class="form-group col-md-6">
                          <part-input class="form-part" label="${'avatar.form.webhooks.definitions.authKey.label'.t()}"
                            :value="${definition => definition.authorizationKey || ''}"
                            name="webhookAuthorizationKey_${definition => definition.id}" type="password"
                            placeholder="${'avatar.form.webhooks.definitions.authKey.placeholder'.t()}"></part-input>
                        </div>
                      </div>
                      `)}
                      ${(0, fast_element_1.when)((x, c) => c.parent.webhookPayloadExamples[x.id], (0, fast_element_1.html) `<div class="webhook-example-area">
                        <div class="card mb-3">
                          <div class="card-header" style="cursor: pointer;"
                            @click="${(definition, c) => c.parent.toggleWebhookPayloadExample(definition.id)}">
                            <div class="d-flex justify-content-between align-items-center">
                              <h6 class="mt-3 mb-0">${'avatar.form.webhooks.payload.title'.t()}: ${definition => definition.name || 'avatar.form.webhooks.definitions.untitled'.t()}</h6>
                              ${(x, c) => console.log(x, c.parent.webhookPayloadExamplesOpened[x.id], 'xxx')}
                              <i
                                class="${(definition, c) => c.parent.webhookPayloadExamplesOpened[definition.id] ? 'simple-icon-arrow-up' : 'simple-icon-arrow-down'}"></i>
                            </div>
                          </div>
                          ${(0, fast_element_1.when)((x, c) => c.parent.webhookPayloadExamplesOpened[x.id], (0, fast_element_1.html) `
                          <div class="card-body">
                            <h6>${'avatar.form.webhooks.payload.subtitle'.t()}</h6>
                            <p class="text-muted small">${'avatar.form.webhooks.payload.description'.t()}</p>
                            <code-screen class="share-preview" showTime="true" componentId="x1"
                              language="json">${(definition, c) => c.parent.webhookPayloadExamples[definition.id] ||
    ''}</code-screen>
                          </div>
                          `)}
                        </div>
                        `)}
                      </div>
                    </div>
                    `)}
                  </div>
                </div>
              </div>
              `)}

              

              
              ${(0, fast_element_1.when)(x => x.activeTab === 'apiTools', (0, fast_element_1.html) `
              <div class="tab-pane active" role="tabpanel">
                <div class="form-group mt-4">
                  <h5>${'avatar.form.apiTools.title'.t()}</h5>
                  <p class="text-muted mb-4">${'avatar.form.apiTools.description'.t()}</p>
                  <api-tool-setup
                    :enabled="${x => x.apiToolsEnabled}"
                    :definitions="${x => x.form.apiToolDefinitions || []}"
                    @api-tools-changed="${(x, c) => x.onApiToolsChanged(c.event)}"></api-tool-setup>
                </div>
              </div>
              `)}

              
              ${(0, fast_element_1.when)(x => x.activeTab === 'lexicon', (0, fast_element_1.html) `
              <div class="tab-pane active" role="tabpanel">
                
                <div class="form-group mt-4">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5>${'avatar.form.lexicon.title'.t()}</h5>
                    <button type="button" class="btn btn-primary btn-sm" @click="${x => x.addLexiconEntry()}">
                      <i class="simple-icon-plus mr-1"></i>${'avatar.form.lexicon.add'.t()}
                    </button>
                  </div>

                  ${(0, fast_element_1.when)(x => !x.form.lexicon || x.form.lexicon.length === 0, (0, fast_element_1.html) `
                  <div class="alert alert-info">
                    <i class="simple-icon-info mr-2"></i>${'avatar.form.lexicon.empty'.t()}
                  </div>
                  `)}

                  ${(0, fast_element_1.repeat)(x => x.form.lexicon || [], (0, fast_element_1.html) `
                  <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">${entry => entry.label || 'avatar.form.lexicon.untitled'.t()}</h6>
                      <div>
                        <button type="button" class="btn btn-danger btn-sm"
                          @click="${(entry, c) => c.parent.removeLexiconEntry(entry)}">
                          <i class="simple-icon-trash"></i>
                        </button>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <part-input class="form-part" label="${'avatar.form.lexicon.label.label'.t()}"
                            :value="${entry => entry.label}" name="lexiconLabel_${entry => entry.id}"
                            placeholder="${'avatar.form.lexicon.label.placeholder'.t()}"></part-input>
                        </div>
                        <div class="form-group col-md-6">
                          <part-input class="form-part" label="${'avatar.form.lexicon.value.label'.t()}"
                            :value="${entry => entry.value}" name="lexiconValue_${entry => entry.id}"
                            placeholder="${'avatar.form.lexicon.value.placeholder'.t()}"
                            type="${entry => entry.hidden ? 'password' : 'text'}"></part-input>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <part-switch class="form-part" label="${'avatar.form.lexicon.hidden.label'.t()}"
                            :value="${entry => entry.hidden}" name="lexiconHidden_${entry => entry.id}"></part-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                  `)}
                </div>
              </div>
              `)}

              
              ${(0, fast_element_1.when)(x => x.isUserSuperAdmin && x.activeTab === 'rag', (0, fast_element_1.html) `
              <div class="tab-pane active" role="tabpanel">
                <div class="card">
                  <div class="card-header">
                    <h5 class="mb-0">
                      <i class="fas fa-search mr-2"></i>${'avatar.form.rag.settings.title'.t()}
                    </h5>
                  </div>
                  <div class="card-body">
                    <p class="text-muted mb-4">${'avatar.form.rag.settings.description'.t()}</p>

                    <rag-settings @rag-settings-changed="${(x, c) => x.onRagSettingsChanged(c.event)}"
                      :ragSettings="${x => x.form.ragSettings}" formNamePrefix="ragSettings"
                      ref="${(0, fast_element_1.ref)('ragSettingsComponent')}"></rag-settings>
                  </div>
                </div>
              </div>
              `)}
            </div>

            
            <div class="form-group mt-4">
              <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary btn-lg mr-2"
                ?disabled="${x => x.loading}">
                ${x => x.avatarId ? 'avatar.form.submit.saveAndReturn.update'.t() : 'avatar.form.submit.saveAndReturn.create'.t()}
              </button>
              <button @click="${(x, c) => x.saveStay(c)}" type="submit" class="btn btn-secondary btn-lg mr-2"
                ?disabled="${x => x.loading}">
                  ${x => x.avatarId ? 'avatar.form.submit.update'.t() : 'avatar.form.submit.create'.t()}
              </button>
            </div>
          </the-form>
        </div>
      </div>
    </div>
  </div>
  ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader></app-loader>`)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.nav-fill .nav-item {
  flex: inherit;
}

@media (max-width: 768px) {
  .nav-tabs .nav-link {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
  }
}
model-select {
  position: relative;
  z-index: 3;
}

.avatar-logo-preview img {
  max-width: 150px;
  border: 2px solid #dee2e6;
  border-radius: 0.375rem;
}

.instructions .title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}
.instructions .title-wrapper .col-3 {
  width: 400px;
}
.instructions .version-entry {
  padding: 5px;
}
.instructions .version-entry:nth-child(odd) {
  background-color: var(--chat_header_color);
}
.instructions .version-entry:hover {
  background-color: #fada96;
}`;
const shadowOptions = { "mode": "open" };
let AvatarForm = class AvatarForm extends client_1.RWSViewComponent {
    ;
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.loading = false;
        this.showColor = false;
        this.avatarId = null;
        this.activeTab = 'configuration';
        this.genderOptions = backendImport_1.GenderEnum.GenderOptions.map((item) => {
            item.label = `gender.${item.label.toLowerCase}`.t();
            return item;
        });
        this.voiceOptions = [];
        this.selectedAzureVoice = null;
        this.availableTools = [];
        this.webhookEventTypeOptions = Object.values(backendImport_1.WebhookEventType).map(type => ({
            label: `webhook.eventTypes.${type}`.t(),
            value: type
        }));
        this.cronIntervalOptions = [
            { label: 'webhook.cronIntervals.every_5_minutes'.t(), value: '*/5 * * * *' },
            { label: 'webhook.cronIntervals.every_10_minutes'.t(), value: '*/10 * * * *' },
            { label: 'webhook.cronIntervals.every_15_minutes'.t(), value: '*/15 * * * *' },
            { label: 'webhook.cronIntervals.every_30_minutes'.t(), value: '*/30 * * * *' },
            { label: 'webhook.cronIntervals.every_45_minutes'.t(), value: '*/45 * * * *' },
            { label: 'webhook.cronIntervals.every_hour'.t(), value: '0 * * * *' },
            { label: 'webhook.cronIntervals.every_2_hours'.t(), value: '0 */2 * * *' },
            { label: 'webhook.cronIntervals.every_6_hours'.t(), value: '0 */6 * * *' },
            { label: 'webhook.cronIntervals.every_12_hours'.t(), value: '0 */12 * * *' },
            { label: 'webhook.cronIntervals.daily'.t(), value: '0 0 * * *' },
            { label: 'webhook.cronIntervals.weekly'.t(), value: '0 0 * * 0' }
        ];
        this.webhookPayloadExamples = {};
        this.webhookPayloadExamplesOpened = {};
        this.apiToolsEnabled = false;
        this.instructionVersions = {};
        this.instructionVersionsOpen = {};
        this.instructionVersionsLoading = {};
        this.ragSettingsComponent = null;
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
        this.stayOnPage = false;
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_3.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_3.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    async connectedCallback() {
        this.resetForm();
        // Initialize available tools
        this.initializeTools();
        super.connectedCallback();
        this.avatarId = this.routeParams.id;
        if (this.avatarId) {
            await this.loadAvatar();
        }
        window.addEventListener('hashchange', this.handleHashChange.bind(this));
        this.handleHashChange();
        // Get RAG settings component reference after template is rendered
        setTimeout(() => {
            console.log('📊 Avatar Form: Getting RAG settings component reference');
            this.ragSettingsComponent = this.$('rag-settings');
            console.log('📊 Avatar Form: RAG settings component found:', {
                componentExists: !!this.ragSettingsComponent,
                formRagSettings: this.form.ragSettings
            });
            if (this.ragSettingsComponent && this.form.ragSettings) {
                console.log('📊 Avatar Form: Calling setSettings in timeout');
                this.ragSettingsComponent.setSettings(this.form.ragSettings);
            }
            else {
                console.warn('📊 Avatar Form: RAG component or settings not available in timeout');
            }
        }, 100);
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
        // Load Azure voices
        await this.loadAzureVoices();
        this.updateVoiceOptions();
        this.on(events_1.inputEvents.changed, (event) => {
            if (event.detail.fieldName === 'gender') {
                // Update voice options when gender changes
                this.updateVoiceOptions();
                // Clear voice if it's not valid for the new gender
                if (this.form.voice && event.detail.value) {
                    const selectedVoice = voices_helper_1.AzureVoicesHelper.findAzureVoiceByName(this.form.voice);
                    const isVoiceValidForGender = selectedVoice &&
                        (event.detail.value === selectedVoice.gender);
                    if (!isVoiceValidForGender) {
                        setTimeout(() => {
                            this.form = { ...this.form, voice: '' };
                            this.selectedAzureVoice = null;
                        }, 10);
                    }
                }
                setTimeout(() => {
                    this.form = { ...this.form };
                }, 10);
            }
            if (event.detail.fieldName === 'voice') {
                this.onVoiceChange(event.detail.value);
            }
            if (event.detail.fieldName.startsWith('enabledTool_')) {
                delete this.form[event.detail.fieldName];
                const toolName = event.detail.fieldName.replace('enabledTool_', '');
                const isEnabled = event.detail.value;
                if (isEnabled) {
                    if (!this.form.enabledTools.includes(toolName)) {
                        this.form.enabledTools.push(toolName);
                    }
                }
                else {
                    this.form.enabledTools = this.form.enabledTools.filter(name => name !== toolName);
                }
            }
            // Handle webhook definition fields
            if (event.detail.fieldName.startsWith('webhook') && event.detail.fieldName.includes('_')) {
                this.handleWebhookFieldChange(event.detail.fieldName, event.detail.value);
            }
            // Handle lexicon entry fields
            if (event.detail.fieldName.startsWith('lexicon') && event.detail.fieldName.includes('_')) {
                this.handleLexiconFieldChange(event.detail.fieldName, event.detail.value);
            }
            // Handle instruction entry fields
            if (event.detail.fieldName.startsWith('instruction') && event.detail.fieldName.includes('_')) {
                delete this.form[event.detail.fieldName];
                this.handleInstructionFieldChange(event.detail.fieldName, event.detail.value);
            }
        });
        this.on('input:hybrid-change', (event) => {
            console.log({ det: event.detail });
            this.showColor = !event.detail.labelShow;
        });
    }
    async disconnectedCallback() {
        window.removeEventListener('hashchange', this.handleHashChange.bind(this));
        super.disconnectedCallback();
    }
    handleHashChange() {
        const tabName = window.location.hash.substring(1);
        if (!tabName || tabName === this.activeTab) {
            return;
        }
        console.log('window', window.location.hash);
        this.switchTab(tabName);
    }
    async loadAvatar() {
        var _a;
        if (!this.avatarId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('avatar.get', {
                routeParams: { id: this.avatarId }
            });
            const avatar = response.data;
            if (avatar) {
                this.form = {
                    name: avatar.name,
                    description: avatar.description,
                    gender: avatar.gender,
                    age: avatar.age,
                    voice: avatar.voice || '',
                    model: avatar.model,
                    isVoiceAgent: avatar.isVoiceAgent || false,
                    logo: avatar.logo,
                    avatarInstructions: (avatar.avatarInstructions || []).map((instr) => {
                        var _a, _b, _c, _d, _e;
                        return ({
                            id: String(instr.id),
                            layer: ((_a = instr.lastVersion) === null || _a === void 0 ? void 0 : _a.layer) || '',
                            color: ((_b = instr.lastVersion) === null || _b === void 0 ? void 0 : _b.color) || '',
                            notes: ((_c = instr.lastVersion) === null || _c === void 0 ? void 0 : _c.notes) || '',
                            instructionPrompt: ((_d = instr.lastVersion) === null || _d === void 0 ? void 0 : _d.instructionPrompt) || '',
                            file: ((_e = instr.lastVersion) === null || _e === void 0 ? void 0 : _e.file) || null,
                            isPublic: instr.isPublic || false,
                            isChanged: false
                        });
                    }),
                    knowledgeIds: avatar.knowledgeEntries ? avatar.knowledgeEntries.map(k => k.id.toString()) : [],
                    fullKnowledgeIds: avatar.fullKnowledgeIds || [],
                    common: avatar.common || false,
                    active: avatar.active !== undefined ? avatar.active : true,
                    enabledTools: avatar.enabledTools || [],
                    webhookDefinitions: avatar.webhookDefinitions || [], lexicon: avatar.lexicon || [], apiToolsEnabled: avatar.apiToolsEnabled || false,
                    apiToolDefinitions: avatar.apiToolDefinitions || [],
                    ragSettings: avatar.ragSettings || {
                        chunkSize: 650,
                        chunkOverlap: 150,
                        separators: ['.\n\n', '\n'],
                        defaultMaxResults: 3,
                        maxResults: 6,
                        similarityThreshold: 0.3
                    }
                };
                // Update tool selection based on avatar data
                this.updateToolSelection();
                // Update API tools enabled state
                this.apiToolsEnabled = avatar.apiToolsEnabled || false;
                if (this.ragSettingsComponent && this.form.ragSettings) {
                    this.ragSettingsComponent.setSettings(this.form.ragSettings);
                }
                if (this.form.webhookDefinitions) {
                    for (const definition of this.form.webhookDefinitions) {
                        if (definition.eventType) {
                            this.produceFakeJsonPayload(definition.id, definition.eventType);
                        }
                    }
                }
            }
        }
        catch (e) {
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('avatar.form.error.load_failed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    saveStay(c) {
        this.stayOnPage = true;
        this.sendSubmit(this, c);
    }
    formChanged(oldVal, newVal) {
        // Form change handling is done in the inputEvents.changed event listener
        // to avoid conflicts with the reactive form system
    }
    get currentVoiceOptions() {
        return this.voiceOptions;
    }
    /**
     * Load available Azure voices from the API using AzureVoicesHelper
     */
    async loadAzureVoices() {
        try {
            const voices = await voices_helper_1.AzureVoicesHelper.loadAzureVoicesFromAPI(this.apiService);
            console.log('🎤 [AvatarForm] Loaded', voices.length, 'Azure voices');
        }
        catch (error) {
            console.error('Failed to load Azure voices:', error);
        }
    }
    /**
     * Update voice options based on gender selection
     */
    updateVoiceOptions() {
        var _a;
        const options = [{ label: 'avatar.form.voice.placeholder'.t(), value: '' }];
        const currentGender = (_a = this.form) === null || _a === void 0 ? void 0 : _a.gender;
        if (currentGender === 'male') {
            const maleVoices = voices_helper_1.AzureVoicesHelper.getVoicesByGender('male');
            options.push(...maleVoices.map(voice => ({
                label: `🎤 ${voice.displayName} (${voice.language})`,
                value: voice.name
            })));
        }
        else if (currentGender === 'female') {
            const femaleVoices = voices_helper_1.AzureVoicesHelper.getVoicesByGender('female');
            options.push(...femaleVoices.map(voice => ({
                label: `🎤 ${voice.displayName} (${voice.language})`,
                value: voice.name
            })));
        }
        else {
            // Show all voices if no gender selected
            const allVoices = voices_helper_1.AzureVoicesHelper.getAzureVoices();
            options.push(...allVoices.map(voice => ({
                label: `🎤 ${voice.displayName} (${voice.language}) ${voice.gender === 'male' ? '👨' : '👩'}`,
                value: voice.name
            })));
        }
        this.voiceOptions = options;
    }
    /**
     * Handle voice selection change
     */
    onVoiceChange(voice) {
        this.form.voice = voice;
        // Update selected Azure voice using helper
        this.selectedAzureVoice = voices_helper_1.AzureVoicesHelper.findAzureVoiceByName(voice);
    }
    back() {
        component_2.SiteMenu.goto.bind(this)('/avatar/list');
    }
    async handleSubmit(event, redirectAfterSubmit = true) {
        var _a, _b, _c;
        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }
        if (this.stayOnPage) {
            this.stayOnPage = false;
            redirectAfterSubmit = false;
        }
        if (!this.form.model) {
            this.popupService.error('avatar.form.error.model_required'.t());
            return;
        }
        // Validate that every instruction entry has a file
        if (this.form.avatarInstructions && this.form.avatarInstructions.length > 0) {
            const missingFile = this.form.avatarInstructions.find(instr => !instr.file);
            if (missingFile) {
                this.popupService.error('avatar.form.error.instruction_file_required'.t());
                this.activeTab = 'instructions';
                return;
            }
        }
        try {
            this.loading = true;
            let response;
            let actionText = this.avatarId ? 'avatar.form.action.updated'.t() : 'avatar.form.action.created'.t();
            if (this.avatarId) {
                console.log(`Submitting update for avatar ID ${this.avatarId} with data:`, this.form);
                response = await this.apiService.back.put('avatar.update', { ...this.form, lang: (0, translations_1.getLanguage)() }, { routeParams: { id: this.avatarId } });
                (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('avatar.form.success.updated'.t(), 'info');
            }
            else {
                response = await this.apiService.back.post('avatar.create', { ...this.form, lang: (0, translations_1.getLanguage)() });
            }
            if (response && response.success) {
                // this.notifyService?.notify(`${'avatar.form.success.action_completed'.t()} ${actionText}`, 'info');                
                if (redirectAfterSubmit) {
                    this.resetForm();
                    component_2.SiteMenu.goto.bind(this)('/avatar/list');
                }
                else {
                    if (this.avatarId) {
                        this.resetForm();
                        this.loadAvatar();
                    }
                    else {
                        component_2.SiteMenu.goto.bind(this)(`/avatar/form/${response.data.id}`);
                    }
                    ;
                }
            }
            else {
                (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify(`${'avatar.form.error.action_failed'.t()} ${actionText}`, 'error');
            }
        }
        catch (e) {
            console.error(e);
            (_c = this.notifyService) === null || _c === void 0 ? void 0 : _c.notify(`${'avatar.form.error.general_error'.t()} ${this.avatarId ? 'avatar.form.action.update'.t() : 'avatar.form.action.create'.t()}`, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    resetForm() {
        this.form = {
            name: '',
            description: '',
            gender: null,
            age: null,
            voice: '',
            image: '',
            model: null,
            logo: null,
            avatarInstructions: [],
            knowledgeIds: [],
            fullKnowledgeIds: [],
            common: false,
            active: true,
            isVoiceAgent: false,
            enabledTools: [],
            webhookDefinitions: [],
            lexicon: [],
            apiToolsEnabled: false,
            apiToolDefinitions: [],
            ragSettings: {
                chunkSize: 650,
                chunkOverlap: 150,
                separators: ['.\n\n', '\n'],
                defaultMaxResults: 3,
                maxResults: 6,
                similarityThreshold: 0.3
            }
        };
    }
    onSelect(selected) {
        this.form = { ...this.form, model: selected };
    }
    onLogoUpload(event) {
        this.form.logo = event.data;
    }
    /**
     * Add a new avatar instruction entry
     */
    addInstructionEntry() {
        if (!this.form.avatarInstructions) {
            this.form.avatarInstructions = [];
        }
        const newEntry = {
            id: `new_${(0, uuid_1.v4)()}`,
            layer: `${'avatar.form.instructions.layer.label'.t()} ${String(this.form.avatarInstructions.length + 1)}`,
            color: '',
            notes: '',
            instructionPrompt: '',
            file: null,
            isPublic: false,
            isChanged: true
        };
        this.form.avatarInstructions.push(newEntry);
        this.form = { ...this.form };
    }
    /**
     * Remove an avatar instruction entry
     */
    removeInstructionEntry(entry) {
        if (!this.form.avatarInstructions)
            return;
        this.form.avatarInstructions = this.form.avatarInstructions.filter(instr => instr.id !== entry.id);
        this.form = { ...this.form };
    }
    /**
     * Handle file upload for a specific instruction entry
     */
    onInstructionFileUpload(entryId, event) {
        if (!this.form.avatarInstructions)
            return;
        this.form.avatarInstructions = this.form.avatarInstructions.map(instr => {
            if (instr.id !== entryId)
                return instr;
            return { ...instr, file: event.data, isChanged: true };
        });
        this.form = { ...this.form };
    }
    /**
     * Handle instruction entry field changes
     */
    handleInstructionFieldChange(fieldName, value) {
        const parts = fieldName.split('_');
        if (parts.length < 2)
            return;
        const entryId = parts.slice(1).join('_');
        const fieldType = parts[0].replace('instruction', '').toLowerCase();
        if (!this.form.avatarInstructions)
            return;
        const formInstructions = this.form.avatarInstructions.map(entry => {
            if (entry.id !== entryId)
                return entry;
            const updatedEntry = { ...entry, isChanged: true };
            switch (fieldType) {
                case 'layer':
                    updatedEntry.layer = value;
                    break;
                case 'color':
                    updatedEntry.color = value;
                    break;
                case 'notes':
                    updatedEntry.notes = value;
                    break;
                case 'prompt':
                    updatedEntry.instructionPrompt = value;
                    break;
                case 'file':
                    updatedEntry.file = value;
                    break;
                case 'public':
                    updatedEntry.isPublic = value;
                    break;
            }
            return updatedEntry;
        });
        this.form = { ...this.form, avatarInstructions: formInstructions };
    }
    /**
     * Toggle version history panel for an instruction entry
     */
    async toggleVersionHistory(entryId) {
        if (String(entryId).startsWith('new_'))
            return;
        const isOpen = this.instructionVersionsOpen[entryId];
        if (isOpen) {
            this.instructionVersionsOpen = { ...this.instructionVersionsOpen, [entryId]: false };
            return;
        }
        // Fetch versions if not already loaded
        if (!this.instructionVersions[entryId]) {
            await this.loadInstructionVersions(entryId);
        }
        this.instructionVersionsOpen = { ...this.instructionVersionsOpen, [entryId]: true };
    }
    /**
     * Load version history for a specific instruction
     */
    async loadInstructionVersions(instructionId) {
        console.log({ instructionId });
        this.instructionVersionsLoading = { ...this.instructionVersionsLoading, [instructionId]: true };
        try {
            const response = await this.apiService.back.get('avatar.instruction.versions', {
                routeParams: { instructionId }
            });
            if (response.success && response.data) {
                this.instructionVersions = { ...this.instructionVersions, [instructionId]: response.data };
            }
        }
        catch (e) {
            console.error('Failed to load instruction versions:', e);
        }
        finally {
            this.instructionVersionsLoading = { ...this.instructionVersionsLoading, [instructionId]: false };
        }
    }
    /**
     * Restore an instruction entry to a specific version
     */
    async restoreInstructionVersion(entryId, version) {
        if (!this.form.avatarInstructions)
            return;
        const confirmed = await this.popupService.confirm('avatar.form.instructions.versions.restore_confirm'.t());
        if (!confirmed)
            return;
        const newVersionResponse = await this.apiService.back.get('avatar.instruction.revert', {
            routeParams: { instructionId: entryId, versionId: version.id }
        });
        const newVersion = newVersionResponse.data;
        if (!newVersion) {
            return;
        }
        this.form.avatarInstructions = this.form.avatarInstructions.map(entry => {
            if (entry.id !== entryId)
                return entry;
            return {
                ...entry,
                id: entryId,
                layer: newVersion.layer || '',
                color: newVersion.color || '',
                notes: newVersion.notes || '',
                instructionPrompt: newVersion.instructionPrompt || '',
                file: newVersion.file,
                isChanged: false
            };
        });
        this.loadInstructionVersions(entryId);
        this.form = { ...this.form };
        this.instructionVersionsOpen = { ...this.instructionVersionsOpen, [entryId]: false };
    }
    onKnowledgeSelectionChanged(event) {
        this.form.knowledgeIds = event.detail.selectedIds;
        this.form.fullKnowledgeIds = event.detail.fullKnowledgeIds || [];
        // Commented out automatic form submission after knowledge selection change
        if (this.avatarId) {
            this.handleSubmit(event, false);
        }
    }
    switchTab(tabName) {
        this.activeTab = tabName;
        if (window.location.hash.substring(1) !== tabName) {
            window.location.hash = tabName;
        }
    }
    // activeTabChanged(oldVal: string, newVal: string) {
    //     if(oldVal && newVal && oldVal !== newVal){
    //         console.log('changed tab', {oldVal, newVal});
    //         window.location.hash = newVal;
    //     }
    // }
    onRagSettingsChanged(event) {
        this.form.ragSettings = { ...event.detail.settings };
    }
    onApiToolsChanged(event) {
        this.apiToolsEnabled = event.detail.enabled;
        this.form.apiToolsEnabled = event.detail.enabled;
        this.form.apiToolDefinitions = event.detail.definitions;
    }
    /**
     * Initialize available tools
     */
    initializeTools() {
        this.availableTools = AVAILABLE_TOOLS.map(tool => ({
            ...tool,
            enabled: false
        }));
    }
    /**
     * Update tool selection based on form data
     */
    updateToolSelection() {
        this.availableTools = this.availableTools.map(tool => {
            var _a;
            return ({
                ...tool,
                enabled: ((_a = this.form.enabledTools) === null || _a === void 0 ? void 0 : _a.includes(tool.name)) || false
            });
        });
    }
    /**
     * Handle tool selection change
     */
    onToolSelectionChange(toolName, enabled) {
        if (!this.form.enabledTools) {
            this.form.enabledTools = [];
        }
        if (enabled && !this.form.enabledTools.includes(toolName)) {
            this.form.enabledTools.push(toolName);
        }
        else if (!enabled && this.form.enabledTools.includes(toolName)) {
            this.form.enabledTools = this.form.enabledTools.filter(tool => tool !== toolName);
        }
        // Update available tools display with correct enabled state
        this.availableTools = this.availableTools.map(tool => {
            var _a;
            return ({
                ...tool,
                enabled: ((_a = this.form.enabledTools) === null || _a === void 0 ? void 0 : _a.includes(tool.name)) || false
            });
        });
        // Trigger form change
        this.form = { ...this.form };
    }
    /**
     * Add a new webhook definition
     */
    addWebhookDefinition() {
        if (!this.form.webhookDefinitions) {
            this.form.webhookDefinitions = [];
        }
        const newDefinition = {
            id: (0, uuid_1.v4)(),
            name: '',
            address: '',
            eventType: backendImport_1.WebhookEventType.CONVERSATION_ANALYSIS,
            cronEnabled: false,
            cronInterval: '*/30 * * * *', // Every 30 minutes by default
            active: true,
            authorizationEnabled: false,
            authorizationHeader: '',
            authorizationKey: ''
        };
        this.form.webhookDefinitions.push(newDefinition);
        this.form = { ...this.form };
    }
    /**
     * Remove a webhook definition
     */
    removeWebhookDefinition(definition) {
        if (!this.form.webhookDefinitions)
            return;
        this.form.webhookDefinitions = this.form.webhookDefinitions.filter(def => def.id !== definition.id);
        this.form = { ...this.form };
    }
    /**
     * Handle webhook definition field changes
     */
    handleWebhookFieldChange(fieldName, value) {
        const parts = fieldName.split('_');
        if (parts.length < 2)
            return;
        const definitionId = parts.slice(1).join('_');
        const fieldType = parts[0].replace('webhook', '').toLowerCase();
        if (!this.form.webhookDefinitions)
            return;
        // Create new array with new object references to ensure reactivity
        const formWebhooks = this.form.webhookDefinitions.map(definition => {
            if (definition.id !== definitionId) {
                return definition; // Keep unchanged definitions as-is
            }
            // Create new object for the definition being changed
            const updatedDefinition = { ...definition };
            switch (fieldType) {
                case 'name':
                    updatedDefinition.name = value;
                    break;
                case 'address':
                    updatedDefinition.address = value;
                    break;
                case 'eventtype':
                    updatedDefinition.eventType = value;
                    this.produceFakeJsonPayload(definition.id, value);
                    break;
                case 'croninterval':
                    updatedDefinition.cronInterval = value;
                    break;
                case 'cronenabled':
                    updatedDefinition.cronEnabled = value;
                    break;
                case 'active':
                    updatedDefinition.active = value;
                    break;
                case 'authorizationenabled':
                    updatedDefinition.authorizationEnabled = value;
                    // Clear authorization fields when disabled
                    if (!value) {
                        updatedDefinition.authorizationHeader = '';
                        updatedDefinition.authorizationKey = '';
                    }
                    break;
                case 'authorizationheader':
                    updatedDefinition.authorizationHeader = value;
                    break;
                case 'authorizationkey':
                    updatedDefinition.authorizationKey = value;
                    break;
            }
            return updatedDefinition;
        });
        // Update form with new array reference
        this.form = { ...this.form, webhookDefinitions: formWebhooks };
        console.log('Updated webhooks:', this.form.webhookDefinitions);
    }
    /**
     * Add a new lexicon entry
     */
    addLexiconEntry() {
        if (!this.form.lexicon) {
            this.form.lexicon = [];
        }
        const newEntry = {
            id: (0, uuid_1.v4)(),
            label: '',
            value: '',
            hidden: false
        };
        this.form.lexicon.push(newEntry);
        this.form = { ...this.form };
    }
    /**
     * Remove a lexicon entry
     */
    removeLexiconEntry(entry) {
        if (!this.form.lexicon)
            return;
        this.form.lexicon = this.form.lexicon.filter(lex => lex.id !== entry.id);
        this.form = { ...this.form };
    }
    /**
     * Handle lexicon entry field changes
     */
    handleLexiconFieldChange(fieldName, value) {
        const parts = fieldName.split('_');
        if (parts.length < 2)
            return;
        const entryId = parts.slice(1).join('_');
        const fieldType = parts[0].replace('lexicon', '').toLowerCase();
        if (!this.form.lexicon)
            return;
        // Create new array with new object references to ensure reactivity
        const formLexicon = this.form.lexicon.map(entry => {
            if (entry.id !== entryId) {
                return entry; // Keep unchanged entries as-is
            }
            // Create new object for the entry being changed
            const updatedEntry = { ...entry };
            switch (fieldType) {
                case 'label':
                    updatedEntry.label = value;
                    break;
                case 'value':
                    updatedEntry.value = value;
                    break;
                case 'hidden':
                    updatedEntry.hidden = value;
                    break;
            }
            return updatedEntry;
        });
        // Update form with new array reference
        this.form = { ...this.form, lexicon: formLexicon };
        console.log('Updated lexicon:', this.form.lexicon);
    }
    async produceFakeJsonPayload(webhookId, webhookType) {
        try {
            const response = await this.apiService.back.get('avatar.fake-webhook-schema', { routeParams: { webhookEventName: webhookType } });
            if (response && response.schema) {
                this.webhookPayloadExamples = { ...this.webhookPayloadExamples, [webhookId]: response.schema };
            }
        }
        catch (error) {
            console.error('Error generating fake webhook payload:', error);
        }
    }
    toggleWebhookPayloadExample(webhookId) {
        const isOpened = this.webhookPayloadExamplesOpened[webhookId] || false;
        this.webhookPayloadExamplesOpened = { ...this.webhookPayloadExamplesOpened, [webhookId]: !isOpened };
    }
};
exports.AvatarForm = AvatarForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarForm.prototype, "showColor", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AvatarForm.prototype, "avatarId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AvatarForm.prototype, "activeTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IAvatarPayload !== "undefined" && backendImport_1.IAvatarPayload) === "function" ? _b : Object)
], AvatarForm.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AvatarForm.prototype, "genderOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AvatarForm.prototype, "voiceOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AvatarForm.prototype, "selectedAzureVoice", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AvatarForm.prototype, "availableTools", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AvatarForm.prototype, "webhookEventTypeOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AvatarForm.prototype, "cronIntervalOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AvatarForm.prototype, "webhookPayloadExamples", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AvatarForm.prototype, "webhookPayloadExamplesOpened", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AvatarForm.prototype, "apiToolsEnabled", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AvatarForm.prototype, "instructionVersions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AvatarForm.prototype, "instructionVersionsOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], AvatarForm.prototype, "instructionVersionsLoading", void 0);
exports.AvatarForm = AvatarForm = __decorate([
    (0, client_1.RWSView)('avatar-form', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], AvatarForm);
AvatarForm.defineComponent();
